export function camelToSnake(camelCase : string) {
    return camelCase.replace(/([a-z])([A-Z])/g, '$1_$2').toLowerCase();
  }